import React, { useState, useEffect, useRef } from "react";
import { useOnScreen } from "./../../hooks/useIntersectionObserver";
import { PaymentBlock, SubscriptionBlock, TimeBlock } from "./styled";
import { Container, Heading, Text } from "../../styled";
import {
  blackColor,
  greyAddColor,
  orangeColor,
  purpleColor,
  whiteColor,
} from "../../constants/colors";
import okIcon from "./../../resources/images/subscription/ok_orange_icon.svg";
import stamp from "./../../resources/images/subscription/stamp.svg";
import methodIcon from "./../../resources/images/subscription/payment_method.png";
import keyIcon from "./../../resources/images/subscription/key.svg";
import stripeIcon from "./../../resources/images/subscription/stripe.png";
import tableIcon from "./../../resources/images/subscription/table.png";
import PopupTemplate from "../design_components/Popup/PopupTemplate";
import PaymentForm from "./PaymentForm/PaymentForm";
import {
  subscribeList,
  comments,
  scrollHeight,
  timeRemaining,
  STRIPE_PUBLIC_KEY,
} from "../../constants/data";
import Button from "../design_components/Button/Button";
import {
  createEventObjectFunction,
  currencyFormatter,
} from "../../utils/helper";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { paywallOpenEventAmplitude } from "../../amplitude/events";
import { paywallOpenEvent } from "../../firebaseAnalytics/events";
import { analytics } from "../../firebaseAnalytics";

const Subscription = (props) => {
  const { userSum, userEmail, pixelObject, landingId } = props;
  const PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
  const [counter, setCounter] = useState(timeRemaining);
  const [isTimeVisible, setTimeVisible] = useState(false);
  const [isPaymentVisible, setPaymentVisible] = useState(false);
  const [isWhyPopupVisible, setWhyPopupVisible] = useState(false);
  const [stripePromise, setStripePromise] = useState(() =>
    loadStripe(PUBLIC_KEY)
  );

  const formBlock = useRef(null);

  const padTime = (time) => {
    return String(time).length === 1 ? `0${time}` : `${time}`;
  };

  const format = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${padTime(seconds)}`;
  };

  const calculateScroll = (e) => {
    if (scrollY > scrollHeight) {
      setTimeVisible(true);
    } else {
      setTimeVisible(false);
    }
  };

  const ref = useRef();
  const refForm = useRef();
  const isVisible = useOnScreen(ref);
  const isVisibleForm = useOnScreen(refForm);

  useEffect(() => {
    console.log(isVisible);
  }, [isVisible]);

  useEffect(() => {
    const eventObj = createEventObjectFunction(null, null, landingId);
    eventObj.type = "short";
    const options = {
      root: document.querySelector(".observer-element"),
      rootMargin: "0px",
      threshold: 1.0,
    };
    // Событие №8 paywall open
    paywallOpenEvent(analytics, eventObj);
    paywallOpenEventAmplitude(eventObj);
    window.addEventListener("scroll", (e) => calculateScroll(e));
    return window.removeEventListener("scroll", (e) => calculateScroll(e));
  }, []);

  useEffect(() => {
    let timer;
    if (counter > 0) {
      timer = setTimeout(() => setCounter((c) => c - 1), 1000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [counter]);

  const commentsRender = () => {
    return comments.map((comment, index) => {
      return (
        <SubscriptionBlock.Comments.Item key={`comment-${index}`}>
          <SubscriptionBlock.Comments.Top>
            <SubscriptionBlock.Comments.Top.Left>
              <img src={comment.avatar} alt="avatar" />
            </SubscriptionBlock.Comments.Top.Left>
            <SubscriptionBlock.Comments.Top.Right>
              <SubscriptionBlock.Comments.Top.Right.Top>
                <Text.Fourth style={{ opacity: 0.7 }}>
                  <b>{`${comment.name}`}</b> recommends <b>Journey</b>
                </Text.Fourth>
              </SubscriptionBlock.Comments.Top.Right.Top>
              <SubscriptionBlock.Comments.Top.Right.Bottom>
                <img src={comment.img} alt="" />
                <Text.Fourth style={{ opacity: 0.7 }}>
                  {comment.count}
                </Text.Fourth>
              </SubscriptionBlock.Comments.Top.Right.Bottom>
            </SubscriptionBlock.Comments.Top.Right>
          </SubscriptionBlock.Comments.Top>
          <SubscriptionBlock.Comments.Bottom>
            <Text.Second style={{ textAlign: "left" }}>
              {comment.text}
            </Text.Second>
          </SubscriptionBlock.Comments.Bottom>
        </SubscriptionBlock.Comments.Item>
      );
    });
  };

  const paymentBlockRender = () => {
    return (
      <PaymentBlock>
        <PaymentBlock.Top>
          <PaymentBlock.Top.Title style={{ marginBottom: 23 }}>
            <Heading.Fifth style={{ color: blackColor }}>
              Payment method
            </Heading.Fifth>
            <Text.Fifth
              style={{ color: orangeColor, fontWeight: 700 }}
              onClick={() => setWhyPopupVisible(true)}
            >
              Why now?
            </Text.Fifth>
          </PaymentBlock.Top.Title>
          {/*<Text.Comment.Name style={{ opacity: 0.7, marginBottom: 12 }}>*/}
          {/*  {`You will only be charged ${currencyFormatter.format(*/}
          {/*    userSum*/}
          {/*  )} for your 7-day trial`}*/}
          {/*</Text.Comment.Name>*/}
          <PaymentBlock.Top.Method>
            <img style={{ height: 31 }} src={methodIcon} alt="Visa" />
          </PaymentBlock.Top.Method>
          <PaymentBlock.Top.Title>
            <Heading.Fifth style={{ color: blackColor }}>
              Payment information
            </Heading.Fifth>
            <Text.Fifth
              style={{
                color: "#6C6C6C",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
              }}
            >
              <img src={keyIcon} alt="" style={{ marginRight: 6 }} />
              <span>Secure Server</span>
            </Text.Fifth>
          </PaymentBlock.Top.Title>
        </PaymentBlock.Top>
        <PaymentBlock.Form>
          <PaymentBlock.Form.Top>
            <span>Powered by</span>
            <img style={{ height: 34 }} src={stripeIcon} alt="" />
          </PaymentBlock.Form.Top>
          <PaymentBlock.Form.Inputs>
            {paymentFormRender()}
          </PaymentBlock.Form.Inputs>
          <SubscriptionBlock.List.Items>
            <SubscriptionBlock.List.Item>
              <SubscriptionBlock.List.Item.Img>
                <img src={okIcon} alt="ok" />
              </SubscriptionBlock.List.Item.Img>
              <SubscriptionBlock.List.Item.Text>
                <Text.Third>{`7-day trial for ${currencyFormatter.format(
                  userSum
                )}`}</Text.Third>
              </SubscriptionBlock.List.Item.Text>
            </SubscriptionBlock.List.Item>
            <SubscriptionBlock.List.Item>
              <SubscriptionBlock.List.Item.Img>
                <img src={okIcon} alt="ok" />
              </SubscriptionBlock.List.Item.Img>
              <SubscriptionBlock.List.Item.Text>
                <Text.Third>
                  You will be sent an email receipt each time your subscription
                  renews
                </Text.Third>
              </SubscriptionBlock.List.Item.Text>
            </SubscriptionBlock.List.Item>
          </SubscriptionBlock.List.Items>
        </PaymentBlock.Form>
      </PaymentBlock>
    );
  };

  const paymentFormRender = () => {
    return (
      <div>
        <Elements stripe={stripePromise}>
          <PaymentForm
            userEmail={userEmail}
            userSum={userSum}
            pixelObject={pixelObject}
          />
        </Elements>
      </div>
    );
  };

  const handleGetMyPlanClick = () => {
    const eventObj = createEventObjectFunction(null, null, landingId);
    eventObj.type = "long";
    // Событие №8 paywall open
    paywallOpenEvent(analytics, eventObj);
    paywallOpenEventAmplitude(eventObj);
    setPaymentVisible(true);
    handleScrollToElement();
  };

  const handleScrollToElement = () => {
    const block = formBlock.current;
    window.scrollTo(0, block.offsetTop);
  };

  const renderPopupContent = () => {
    return (
      <div>
        <Heading.Second style={{ marginBottom: 16, color: blackColor }}>
          Enjoy instant results!
        </Heading.Second>
        <Text.Fourth style={{ color: purpleColor, marginBottom: 16 }}>
          We ask for your payment information now so you can enjoy Journey
          uninterrupted after your <b>7-day trial ends.</b>
        </Text.Fourth>
        <Text.Fourth style={{ color: purpleColor, marginBottom: 47 }}>
          If you cancel anytime before the end of the <b>7-day trial,</b> you
          won’t be charged.
        </Text.Fourth>
        <Button
          type={"default"}
          isGradient={true}
          text={"Got it"}
          action={() => setWhyPopupVisible(false)}
        />
      </div>
    );
  };

  return (
    <SubscriptionBlock>
      <TimeBlock className={isTimeVisible ? "visible" : null}>
        <Text.Third>
          <span
            style={{
              fontWeight: 700,
            }}
          >
            7-day trial offer expires in{" "}
          </span>
          <span
            style={{
              color: orangeColor,
              fontWeight: 700,
            }}
          >
            {counter === 0 ? "0:00" : format(counter)}
          </span>
        </Text.Third>
      </TimeBlock>
      <Container.Content>
        <SubscriptionBlock.Time>
          <Text.Third
            style={{ marginBottom: 12, color: blackColor, textAlign: "left" }}
          >
            <span
              style={{
                fontWeight: 700,
              }}
            >
              Your personalized sleepscape plan{" "}
            </span>
            <span>
              with a 7-day free trial has been reserved for the next 15 minutes.
            </span>
          </Text.Third>
          <Text.Third
            style={{
              marginBottom: 12,
              fontWeight: 700,
              textAlign: "left",
            }}
          >
            <span
              style={{
                fontWeight: 700,
              }}
            >
              Time remaining{" "}
            </span>
            <span
              style={{
                color: orangeColor,
                fontWeight: 700,
              }}
            >
              {counter === 0 ? "0:00" : <span> {format(counter)}</span>}
            </span>
          </Text.Third>
          <Text.Third style={{ color: greyAddColor, textAlign: "left" }}>
            Scroll down to get started!
          </Text.Third>
        </SubscriptionBlock.Time>
        <SubscriptionBlock.Chart>
          <Heading.Third
            style={{
              marginBottom: 7,
              color: blackColor,
              fontWeight: 800,
              fontSize: 24,
            }}
          >
            Get Personalized Sleepscape plan and unlock everything with Journey
            Premium
          </Heading.Third>
          <Text.Fourth style={{ marginBottom: 46, color: blackColor }}>
            Personal Sleep Coach will help you on your way to the perfect sleep
          </Text.Fourth>
          <SubscriptionBlock.Chart.Img>
            <img src={tableIcon} alt="" />
          </SubscriptionBlock.Chart.Img>
        </SubscriptionBlock.Chart>
        <SubscriptionBlock.Cost>
          <div ref={ref}>
            <Button
              className={"observer-element"}
              type={"default"}
              isGradient={true}
              text={"Start 7-Day Free Trial"}
              action={() => handleGetMyPlanClick()}
            />
          </div>
        </SubscriptionBlock.Cost>
        <SubscriptionBlock.Guarantee>
          <Heading.Third style={{ marginBottom: 15 }}>
            100% Money-Back Guarantee
          </Heading.Third>
          <Text.Fourth
            style={{ marginBottom: 15, color: blackColor, textAlign: "left" }}
          >
            We are confident with our service quality and its results. So, if
            you are ready to reach your goals, it’s a risk-free offer. We
            guarantee you’ll see visible results or you’ll receive a full refund
            within 30 days after your purchase.
          </Text.Fourth>
          <Text.Fourth
            style={{ marginBottom: 10, color: blackColor, textAlign: "left" }}
          >
            Eligibility requirements:
          </Text.Fourth>
          <ul>
            <li>
              Submit request within<br></br> 30 days after your purchase
            </li>
            <li>
              Spend 10 consecutive days<br></br> completing at least 1
              sleepscape
            </li>
          </ul>
          <img src={stamp} alt="stamp" />
        </SubscriptionBlock.Guarantee>
        <SubscriptionBlock.Comments>
          <Heading.Third style={{ textAlign: "left", marginBottom: 27 }}>
            People say about Journey
          </Heading.Third>
          {commentsRender()}
        </SubscriptionBlock.Comments>
        <SubscriptionBlock.Form ref={formBlock}>
          <div
            ref={refForm}
            style={{ display: isPaymentVisible ? "block" : "none" }}
          >
            {isPaymentVisible ? paymentBlockRender() : null}
          </div>
        </SubscriptionBlock.Form>
        <SubscriptionBlock.Bottom>
          <Text.Fourth
            style={{ fontWeight: 800, marginBottom: 2, textAlign: "left" }}
          >
            Your information is safe
          </Text.Fourth>
          <Text.Fourth style={{ marginBottom: 24, textAlign: "left" }}>
            We will not sell or rent your personal contact information for any
            marketing purposes whatsoever.
          </Text.Fourth>
          <Text.Fourth
            style={{ fontWeight: 800, marginBottom: 2, textAlign: "left" }}
          >
            Secure checkout
          </Text.Fourth>
          <Text.Fourth style={{ marginBottom: 24, textAlign: "left" }}>
            All information is encrypted and transmitted without risk using a
            Secure Sockets Layer protocol.
          </Text.Fourth>
          <Text.Fourth
            style={{ fontWeight: 800, marginBottom: 2, textAlign: "left" }}
          >
            Need any help?
          </Text.Fourth>
          <Text.Fourth style={{ marginBottom: 24, textAlign: "left" }}>
            <span>Contact us </span>{" "}
            <a
              href="mailto:support@gojourney.app"
              style={{ color: orangeColor, textDecoration: "none" }}
            >
              here
            </a>
          </Text.Fourth>
        </SubscriptionBlock.Bottom>
        <SubscriptionBlock.Footer>
          <SubscriptionBlock.Footer.Top>
            <SubscriptionBlock.Footer.Top.Item>
              <a
                style={{ textDecoration: "none" }}
                href="https://gojourney.notion.site/Terms-of-Use-65e259c58a104be28b9eb63bc53483ea"
              >
                <Text.Third style={{ color: "#8B8991" }}>
                  Terms of Use
                </Text.Third>
              </a>
            </SubscriptionBlock.Footer.Top.Item>
            <SubscriptionBlock.Footer.Top.Item>
              <a
                style={{ textDecoration: "none" }}
                href="https://gojourney.notion.site/Privacy-Policy-9fd584ee90f64a5496698d7a9222687b"
              >
                <Text.Third style={{ color: "#8B8991" }}>
                  Privacy Policy
                </Text.Third>
              </a>
            </SubscriptionBlock.Footer.Top.Item>
          </SubscriptionBlock.Footer.Top>
          <SubscriptionBlock.Footer.Bottom>
            <Text.Fifth style={{ color: "#B0AFB3" }}>
              © 2021 Journey Inc.<br></br> All Rights Reserved.
            </Text.Fifth>
          </SubscriptionBlock.Footer.Bottom>
        </SubscriptionBlock.Footer>
      </Container.Content>
      <SubscriptionBlock.Fixed
        className={!isVisible && !isVisibleForm && "button-visible"}
      >
        <Button
          type={"default"}
          isGradient={true}
          text={"Start 7-Day Free Trial"}
          action={() => handleGetMyPlanClick()}
        />
      </SubscriptionBlock.Fixed>
      {isWhyPopupVisible && (
        <PopupTemplate contentFunction={renderPopupContent} />
      )}
    </SubscriptionBlock>
  );
};

export default Subscription;
